import { FileDescriptorRead, PublicationVersionDescriptor, Status } from "@nens/rana/api-v1";
import { ShapeSatisfies } from "@nens/shared-utils";

type AnyDescriptor =
  | ShapeSatisfies<
      {
        status?: string | { id?: Status };
      },
      FileDescriptorRead | PublicationVersionDescriptor
    >
  | undefined
  | null;

export const descriptorIsLoading = <D extends AnyDescriptor>(descriptor: D) => {
  if (!descriptor) return true;
  const descriptorStatus = descriptor.status;
  const status = typeof descriptorStatus === "string" ? descriptorStatus : descriptorStatus?.id;
  return (
    status === "pending" ||
    status === "processing" ||
    status === "retry" ||
    status === "restarting" ||
    status === "deleting"
  );
};
